function HttpNotFoundInterceptor($q, $injector, $window, loadingIndicator, whiteList) {
    return {
        responseError(rejection) {
        const $state = $injector.get('$state');
        const currentUserService = $injector.get('CurrentUserService');
        const routeService = $injector.get('RouteService');

        if (rejection.status === 401) {
            loadingIndicator.finishLoading();
            if (rejection.data.ActionType && rejection.data.ActionType.toLowerCase() === 'promptlogin') {
                $state.go('shop.authentication.login');
            } else if (rejection.data.ResponseStatus.ErrorCode === 'RegisteredShopperAuthenticationException' ||
                rejection.data.ResponseStatus.ErrorCode === 'RegisteredOrUnregisteredShopperAuthenticationException') {

                /** If you're a guest shopper and your session times out, there's currently no
                *   way to get your trolley back. This, therefore, is not best approach and will
                *   likely change in the future
                **/
                if (currentUserService.currentUser.id !== '') {
                  currentUserService.clear();
                  $window.location.href = '/';
                } else {
                  $state.go('shop.authentication.login');
                }

            } else if ((rejection.statusText.toLowerCase() === 'unauthorized') || (rejection.data.ResponseStatus.ErrorCode === 'FullLoginRequiredAuthenticationException')) {
                // Important removed { reload: true } this was causing an endless loop
                // when session expires and the user is on the myaccount page
                $state.go('shop.persistentlogin', { intendedRoute: routeService.intendedRoute });
            }
        }

        const ignoreUrl = !whiteList.isMatch(rejection.config.url);

        if ((rejection.status === 404 || rejection.status === -1) && ignoreUrl) {
            $state.$current.data.prerender = {
                    name: 'prerender-status-code',
                    value: '404'
                };

            if (!navigator.userAgent || navigator.userAgent.indexOf('Prerender') === -1) {
                const aemIsLoading = routeService.aemRoute && routeService.aemRoute.isloading && routeService.aemRoute.path === document.location.pathname;
                if (aemIsLoading) {
                    routeService.aemRoute.throwNotFound = true;
                } else {
                    const aemLoadedSuccesfully = routeService.aemRoute && !routeService.aemRoute.isloading && !routeService.aemRoute.isError && routeService.aemRoute.path === document.location.pathname;
                    if (!aemLoadedSuccesfully) {
                        $state.go('shop.404error');
                    }
                }
            }

        }

        return $q.reject(rejection);
    }
};
}

module.exports = HttpNotFoundInterceptor;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/interceptors/http-not-found-interceptor.js
 **/